<template>
    <main id="login" class="w-100 h-100">
        <div class="d-flex justify-center justify-content-center">
            <div
                class="content h-100 d-flex flex-column justify-content-center align-items-center"
                style="width: 45%; margin-top: 50px; transition: 1s all"
            >
                <div class="content-form" style="width: 60%">
                    <div style="display: flex; justify-content: space-between; align-items: center">
                        <SupsisLogo />
                        <language-switch />
                    </div>
                    <div style="margin-top: 50px; color: #183b56; font-weight: 700; font-size: 35px">
                        E-posta doğrulama
                    </div>
                    <div style="margin-top: 25px; color: #183b56">
                        <a-alert v-if="status === 'success'" type="success" show-icon>
                            <div slot="message">E-posta adresiniz doğrulandı.</div>
                            <div slot="description">Artık Supsis hesabınıza giriş yapabilirsiniz.</div>
                        </a-alert>
                        <a-alert v-else-if="status === 'error'" type="error" show-icon>
                            <div slot="message">Davet bağlantısı doğrulanamadı.</div>
                            <div slot="description">{{ errorMessage }}</div>
                        </a-alert>
                        <a-alert v-else type="info" show-icon>
                            <div slot="message">Davet bağlantınız kontrol ediliyor.</div>
                        </a-alert>
                    </div>
                    <router-link
                        to="/login"
                        class="w-100 text-white text-center font-weight-bold d-block"
                        style="background: #183b56; border-radius: 8px; padding: 13px 0; font-size: 15px; margin-top: 20px"
                    >
                        Giriş ekranına dön
                    </router-link>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { mapActions } from "vuex";
import SupsisLogo from "../../components/svg/SupsisLogo.vue";
import LanguageSwitch from "../../components/LanguageSwitch";

export default {
    name: "AcceptInvite",
    components: { SupsisLogo, LanguageSwitch },
    data() {
        return {
            status: "loading",
            errorMessage: "Bağlantı geçersiz veya süresi dolmuş olabilir.",
        };
    },
    mounted() {
        const token = this.$route.query.token;
        if (!token) {
            this.status = "error";
            return;
        }
        this.acceptEmailInvitation(token)
            .then(() => {
                this.status = "success";
            })
            .catch((err) => {
                const messages = err.response && err.response.data && err.response.data.localizedMessages;
                this.errorMessage = messages ? messages[this.$i18n.locale] || messages.tr : this.errorMessage;
                this.status = "error";
            });
    },
    methods: {
        ...mapActions({
            acceptEmailInvitation: "user/acceptEmailInvitation",
        }),
    },
};
</script>
